import {v4 as uuid} from 'uuid'

let bookingRequestId: string
export const generateBookingRequestId = (): string => {
  bookingRequestId = uuid()
  return bookingRequestId
}

export const getCurrentBookingRequestId = (): string => {
  return bookingRequestId
}
